import { ImportCandidateDto } from '../import-candidate-dto';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';

export class ImportPackagingUnitCandidateDto extends ImportCandidateDto {
    packagingUnit!: PackagingUnitDto;
}
